// مناطق ومدن المملكة العربية السعودية
// يمكن استبدال هذا الملف ببيانات من API
export const saudiRegions = {
  'الرياض': [
    'الرياض',
    'الخرج',
    'الدوادمي',
    'المجمعة',
    'القويعية',
    'وادي الدواسر',
    'الأفلاج',
    'الزلفي',
    'شقراء',
    'حوطة بني تميم',
    'الغاط',
    'عفيف',
    'السيح',
    'ضرما',
    'المزاحمية',
    'رماح',
    'ثادق',
    'حريملاء',
    'الحريق',
    'الدرعية',
    'الجبيل',
    'الجبيل الصناعية'
  ],
  'مكة المكرمة': [
    'مكة المكرمة',
    'جدة',
    'الطائف',
    'رابغ',
    'القنفذة',
    'الليث',
    'الجموم',
    'خليص',
    'الخرمة',
    'رنية',
    'تربة',
    'الكامل',
    'المويه',
    'ميسان',
    'أضم',
    'العرضيات',
    'بحرة',
    'الطائف',
    'شرورة'
  ],
  'المدينة المنورة': [
    'المدينة المنورة',
    'ينبع',
    'العلا',
    'المهد',
    'بدر',
    'خيبر',
    'الحناكية',
    'العيص',
    'وادي الفرع',
    'المذنب',
    'الأبواء',
    'الفقرة',
    'السيح',
    'العشاش'
  ],
  'القصيم': [
    'بريدة',
    'عنيزة',
    'المذنب',
    'الرس',
    'البكيرية',
    'البدائع',
    'الأسياح',
    'النبهانية',
    'عيون الجواء',
    'الشماسية',
    'عقلة الصقور',
    'ضرية',
    'الخبراء',
    'رياض الخبراء',
    'الأسماك',
    'القرعاء',
    'الشماسية'
  ],
  'الشرقية': [
    'الدمام',
    'الخبر',
    'الأحساء',
    'القطيف',
    'الجبيل',
    'حفر الباطن',
    'الخفجي',
    'رأس تنورة',
    'بقيق',
    'النعيرية',
    'قرية العليا',
    'العديد',
    'الجبيل الصناعية',
    'الجبيل',
    'القطيف',
    'تاروت',
    'صفوى',
    'عنك',
    'الخويلدية',
    'القديح',
    'الملاحة',
    'الخبر',
    'الظهران',
    'رأس تنورة',
    'النعيرية',
    'بقيق',
    'الخفجي',
    'حفر الباطن',
    'قرية العليا',
    'العديد'
  ],
  'عسير': [
    'أبها',
    'خميس مشيط',
    'نجران',
    'جازان',
    'الباحة',
    'بيشة',
    'النماص',
    'ظهران الجنوب',
    'سراة عبيدة',
    'رجال ألمع',
    'أحد رفيدة',
    'المجاردة',
    'تثليث',
    'بلقرن',
    'محايل عسير',
    'البرك',
    'الحرجة',
    'العارضة',
    'الريث',
    'الدرب',
    'صامطة',
    'أبو عريش',
    'صبيا',
    'الداير',
    'الطوال',
    'العارضة',
    'الريث',
    'الدرب',
    'صامطة',
    'أبو عريش',
    'صبيا',
    'الداير',
    'الطوال'
  ],
  'تبوك': [
    'تبوك',
    'الوجه',
    'ضباء',
    'تيماء',
    'أملج',
    'حقل',
    'البدع',
    'شرما',
    'الزيتة',
    'الخريبة',
    'المويلح',
    'الكتيب',
    'البدع',
    'شرما',
    'الزيتة',
    'الخريبة',
    'المويلح',
    'الكتيب'
  ],
  'حائل': [
    'حائل',
    'بقعاء',
    'الغزالة',
    'الشملي',
    'السليمي',
    'الحائط',
    'الشنان',
    'موقق',
    'سميراء',
    'الروضة',
    'الشنان',
    'موقق',
    'سميراء',
    'الروضة'
  ],
  'الحدود الشمالية': [
    'عرعر',
    'رفحاء',
    'طريف',
    'العويقيلة',
    'اللصافة',
    'النعيرية',
    'اللصافة',
    'النعيرية'
  ],
  'جازان': [
    'جازان',
    'صبيا',
    'أبو عريش',
    'صامطة',
    'الداير',
    'الطوال',
    'العارضة',
    'الريث',
    'الدرب',
    'الحرث',
    'العارضة',
    'الريث',
    'الدرب',
    'الحرث'
  ],
  'نجران': [
    'نجران',
    'شرورة',
    'حبونا',
    'بدر الجنوب',
    'يدمة',
    'ثار',
    'الخرخير',
    'حبونا',
    'بدر الجنوب',
    'يدمة',
    'ثار',
    'الخرخير'
  ],
  'الباحة': [
    'الباحة',
    'بلجرشي',
    'المندق',
    'المخواة',
    'قلوة',
    'العقيق',
    'الحجرة',
    'الظفير',
    'الخبت',
    'العقيق',
    'الحجرة',
    'الظفير',
    'الخبت'
  ],
  'الجوف': [
    'سكاكا',
    'القريات',
    'دومة الجندل',
    'طبرجل',
    'صوير',
    'القيصومة',
    'القيصومة'
  ]
};

export const regionNames = Object.keys(saudiRegions);

